import React from 'react'
import { makeStyles } from '@material-ui/core'

import {
  DatePicker as MuiDatePicker,
  DatePickerProps,
} from '@material-ui/pickers'

const useStyles = makeStyles({
  pickerContainer: {
    backgroundColor: '#E8E8E8',
    borderTopLeftRadius: 4,
    borderTopRightRadius: 4,
    '&:hover': {
      backgroundColor: '#DEDEDE',
    },
  },

  label: {
    paddingLeft: 12,
    paddingRight: 12,
    paddingBottom: 6,
  },

  input: {
    paddingLeft: 12,
    paddingRight: 12,
  },
})

export const DatePicker: React.FC<DatePickerProps> = ({
  onChange,
  value,
  label,
  ...others
}) => {
  const classes = useStyles()

  return (
    <MuiDatePicker
      fullWidth
      label={label}
      format="dd/MM/yyyy"
      value={value}
      onChange={onChange}
      className={classes.pickerContainer}
      clearable
      clearLabel="Limpar"
      cancelLabel="Cancelar"
      okLabel="Confirmar"
      InputLabelProps={{
        className: classes.label,
      }}
      inputProps={{
        className: classes.input,
      }}
      {...others}
    />
  )
}
